import { Avatar, Box, Chip, Divider, Drawer, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import { NavSection } from './NavSection';
import { HeaderView } from '../Header/Header';
import useResponsive from '../../../hooks/useResponsive';
import { useDrawerStore } from '../../../hooks/useDrawerStore';
import { useNavSectionStore } from '../../../hooks/useNavSectionStore';
import { useAuthStore } from '../../../hooks/useAuthStore';
import '../../../assets/styles/facturacionv3-app.css';

const themeAvenir = createTheme({
  typography: {
    fontFamily: 'AvenirNextRounded',
    fontSize: 15
  },
})
// ----------------------------------------------------------------------
const NAV_WIDTH = 280
const StyledAccount = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: 'rgb(230, 247, 255)'
}))
// ----------------------------------------------------------------------
export const Nav: React.FC<any> = ({ openNav, onCloseNav }): JSX.Element | any => {
  const { user } = useAuthStore();
  const nameuser = (user?.name && user?.first_surname) ? user?.name +' '+ user?.first_surname : 'username';
  const role = user?.userType || '';

  const isDesktop = useResponsive('up', 'lg', '');
  const { drawerOpen, openDrawer } = useDrawerStore();
  const { navOpen } = useNavSectionStore();
  const { pathname } = useLocation();

  useEffect(() => {
    if (openNav) {
      onCloseNav()
    }
  }, [pathname])
  
  const withNavOpen =  navOpen ? NAV_WIDTH : 0

  /* CON FOTO DE USUARIO */

  const renderContent = (
    <>
      <Grid className='nav-container-main'>
        <Grid className='nav-avatar-container'>
          <Avatar alt={user?.name || 'U'} src="/static/images/avatar/1.jpg" sx={{ width: 45, height: 45 }}/>
        </Grid>
        <Grid>
          <Box className='nav-typeuser-container'>
            <ThemeProvider theme={themeAvenir}>
              <Typography className="nav-nameuser-text">{nameuser}</Typography>
            </ThemeProvider>
          </Box>
          <Box className='nav-typeuser-container'>
            <ThemeProvider theme={themeAvenir}>
              <Chip size="medium" label={role} variant="outlined" sx={{ background: '#EAA158', color: '#FFFFFF', fontSize:'12px' }} />
            </ThemeProvider>
          </Box>
        </Grid>
      </Grid>
      
      <NavSection />
      <Box sx={{ flexGrow: 1 }} />
    </>
  )

  /* CON LOGO DE EMPRESA */
  // const renderContent = (
  //   <>
  //     <Box sx={{ display: 'flex', justifyContent:'center', backgroundColor: '#FFFFFF' }}>
  //       <img style={{ width: '150px'}} src={logonav}/>
  //     </Box>
  //     <Box sx={{ display: 'flex', justifyContent:'center' }}>
  //       <ThemeProvider theme={themeAvenir}>
  //         <Chip size="medium" label={'Administrador'} variant="outlined" sx={{ background: '#212D39', color: '#FFFFFF', fontSize:'16px' }} />
  //       </ThemeProvider>
  //     </Box>
  //     <NavSection />
  //     <Box sx={{ flexGrow: 1 }} />
  //   </>
  // )

  return (
      <Box component="nav" sx={{ flexShrink: { lg: 0 }, width: { lg: withNavOpen } }}>

        <HeaderView />

        {
          isDesktop ? (
            navOpen ?
            <Drawer open variant="permanent" 
              PaperProps={{ sx: { width: withNavOpen, bgcolor: 'background.default', borderRightStyle: 'dashed'} }}
            >
              { renderContent }
            </Drawer>
            :
            null
          ) : (
            <Drawer open={drawerOpen} onClose={() => openDrawer(false)} ModalProps={{ keepMounted: true }}
              PaperProps={{ sx: { width: NAV_WIDTH } }}
            >
              {renderContent}
            </Drawer>
          )
        }
      </Box>
  )
}